import { useEffect, useId, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useDialogAccessibility from "../../hooks/useDialogAccessibility";

const CreateCharacterDialog = ({
  isOpen,
  isCreating,
  error,
  onClose,
  onCreate,
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const dialogRef = useRef(null);
  const nameInputRef = useRef(null);
  const titleId = useId();
  const errorId = useId();

  useDialogAccessibility({
    closeDisabled: isCreating,
    containerRef: dialogRef,
    initialFocusRef: nameInputRef,
    isOpen,
    onClose,
  });

  useEffect(() => {
    if (isOpen) setName("");
  }, [isOpen]);

  if (!isOpen) return null;

  const submit = (event) => {
    event.preventDefault();
    const normalizedName = name.trim();
    if (normalizedName) onCreate(normalizedName);
  };

  return (
    <div
      className="character-create-overlay"
      onMouseDown={() => !isCreating && onClose()}
    >
      <form
        aria-labelledby={titleId}
        aria-modal="true"
        className="character-create-dialog"
        ref={dialogRef}
        role="dialog"
        tabIndex="-1"
        onMouseDown={(event) => event.stopPropagation()}
        onSubmit={submit}
      >
        <header>
          <div>
            <p>{t("characters.createEyebrow")}</p>
            <h2 id={titleId}>{t("characters.createTitle")}</h2>
          </div>
          <button
            aria-label={t("common.close")}
            disabled={isCreating}
            type="button"
            onClick={onClose}
          >
            ×
          </button>
        </header>

        <p className="character-create-description">
          {t("characters.createDescription")}
        </p>

        <label>
          {t("characters.name")}
          <input
            aria-describedby={error ? errorId : undefined}
            aria-invalid={Boolean(error)}
            maxLength="80"
            placeholder={t("characters.namePlaceholder")}
            ref={nameInputRef}
            required
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </label>

        {error && <p className="character-create-error" id={errorId} role="alert">{error}</p>}

        <footer>
          <button disabled={isCreating} type="button" onClick={onClose}>
            {t("common.cancel")}
          </button>
          <button
            className="character-create-submit"
            disabled={isCreating}
            type="submit"
          >
            {isCreating ? t("characters.creating") : t("characters.createAndOpen")}
          </button>
        </footer>
      </form>
    </div>
  );
};

export default CreateCharacterDialog;
